// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Bce4","title":"Info_title__NuN30","selects":"Info_selects__2bfiA","requiredAsterisk":"Info_requiredAsterisk__1FKF8"};